const tryToGet = (obj, ...paths) =>
  paths.reduce((a, b) => (a && a[b] ? a[b] : null), obj)

const createMediaQuery = bp => `@media screen and (min-width: ${bp})`

const clean = str => str.replace(/[[\]]/g, '')

function getStyle(value, theme, options) {
  const {propName, cssProp, systemProp} = options
  const cssProp_ = cssProp || propName
  const queries = value.split('] ')

  const style = (val, css=cssProp_) => {
    return Array.isArray(css)
      ? css.reduce((styles, css) => ({...styles, ...style(val, css)}), {})
      : {[css]: val}
  }

  return queries.reduce((styles, query) => {
    let [rule, val] = query.split(':[')
    rule = clean(rule)
    const value = tryToGet(theme, systemProp, rule) || rule
    if (!val) return {...styles, ...style(value)}

    const bp = tryToGet(theme, 'breakpoints', rule)
    val = clean(val)
    const bpValue = tryToGet(theme, systemProp, val) || val
    if (!bp) return {...styles, ...style(bpValue)}

    const mq = createMediaQuery(bp)
    return {...styles, ...style(style(bpValue), mq)}
  }, {})
}

export default function styleFn(opts) {
  return props => {
    const value = props[opts.propName]
    if (!value) return null
    return getStyle(value, props.theme, opts)
  }
}

export function merge(a, b) {
  return {
    ...a,
    ...b,
    ...Object.keys(b || {}).reduce((styles, key) => ({
      ...styles,
      [key]: a[key] !== null && typeof a[key] === 'object'
        ? merge(a[key], b[key])
        : b[key]
    }), {})
  }
}

export function compose(...fns) {
  return props => fns
    .map(fn => fn(props))
    .filter(Boolean)
    .reduce(merge, {})
}
